import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { AuthenticationService } from './index';
import { captureApiError } from './sentry';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
    constructor(private authenticationService: AuthenticationService) {}

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        // console.error('net status', navigator.onLine);
        return next.handle(request).pipe(catchError(err => {
            console.log('ERROR', err);
            if (err.status === 401) {
                // auto logout if 401 response returned from api
                this.authenticationService.logout();
                // location.reload(true);
                location.reload();
            }
            if (this.isUncontrolled(err)) {
                captureApiError(request, err);
            }
            // const error = err.error.message || err.statusText;
            const error = err.error && err.error.Code ? err.error : err.error.error_description || err.error.error || err.error.message || err.statusText;
            return throwError(error);
        }));
    }

    /**
     * Un error es "no controlado" cuando la respuesta no viene en ninguno de los dos contratos que
     * el API usa para los errores esperados. Si no encaja en ninguno, o es un 5xx, es una excepcion
     * que se le escapo al API y hay que reportarla.
     */
    private isUncontrolled(err: HttpErrorResponse): boolean {
        if (err.status === 401) { return false; } // sesion expirada, ya se maneja con el logout
        if (err.status === 0) { return false; }   // sin red o modo offline: esperado, y Sentry tampoco podria enviar
        if (err.status >= 500) { return true; }   // excepcion no controlada del API

        // Contrato de negocio del API: ErrorInfo { Code, Message }
        if (err.error && err.error.Code) { return false; }
        // Contrato OAuth de /token: { error, error_description }. Sin esto, cada contrasenna mal
        // digitada generaria un issue: el login fallido devuelve 400 con invalid_grant.
        if (err.error && err.error.error) { return false; }

        return true;
    }
}
